
























import Vue from 'vue'
import { getPatientName } from '@/utils/patients'
import { buildHeartRateChartOption } from '@/components/patient-stats/graphs/summary-reports/chart-options/heart-rate/heart-rate-chart-options'
import { buildOxygenSaturationChartOption } from '@/components/patient-stats/graphs/summary-reports/chart-options/oxygen-saturation/oxygen-saturation-chart-options'
import { buildBodyWeightChartOption } from '@/components/patient-stats/graphs/summary-reports/chart-options/body-weight/BodyWeightChartOption'
import { USER_TIME_ZONE } from '@/utils/time'
import SummaryOxygenSaturationsCard from '@/components/patient-stats/graphs/summary-reports/SummaryOxygenSaturationsCard.vue'
import SummaryStepCountsCard from '@/components/patient-stats/graphs/summary-reports/SummaryStepCountsCard.vue'
import SummaryBodyWeightsCard from '@/components/patient-stats/graphs/summary-reports/SummaryBodyWeightsCard.vue'
import SummaryHeartRateCard from '@/components/patient-stats/graphs/summary-reports/SummaryHeartRateCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames, GetterNames } from '@/store/modules/patient-with-detailed-reports/keys'
import { FlatPatientWithDetailedReports } from '@/store/modules/patient-with-detailed-reports/getters'
import moment from 'moment-timezone'
import { OFFSET_HOURS_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'
export default Vue.extend({
  components: {
    SummaryOxygenSaturationsCard,
    SummaryStepCountsCard,
    SummaryBodyWeightsCard,
    SummaryHeartRateCard,
  },
  filters: {
    getPatientName,
  },
  props: {
    patientWithStats: {
      type: Object,
      required: true,
    },
    patient: {
      type: Object,
      required: true,
    },
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isInitialized: false,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patientWithDetailedReports, [GetterNames.patientWithDetailedReports]),
    patientWithDetailedReports(): FlatPatientWithDetailedReports {
      return this[GetterNames.patientWithDetailedReports].find(patientWithDR => patientWithDR.id === this.patient.id)
    },
  },
  async mounted() {
    await this.fetchPatientWithDetailedReport()
    this.isInitialized = true
  },
  methods: {
    ...mapActions(ModuleNames.patientWithDetailedReports, [ActionNames.getPatientWithDetailedReportsById]),

    async fetchPatientWithDetailedReport() {
      const lastYearTimestamp = moment()
        .add(-1, 'y')
        .startOf('day')
        .valueOf()
      await this[ActionNames.getPatientWithDetailedReportsById]({
        patientId: this.patient.id,
        startTimestamp: Math.max(lastYearTimestamp, this.startTimestamp - OFFSET_HOURS_TIMESTAMP),
        endTimestamp: this.endTimestamp,
      })
    },
  },
})
